<template>
	<div class="cepbank_form_rsv">

		<div v-if="isLoading">
			İşleminiz gerçekliyor lütfen bekleyin...
		</div>

		<div v-if="formProcess > 0">
			<div class="alert alert-success" v-if="formProcess == 200">
				{{ t.form.success }}
			</div>
			<div class="alert alert-danger" v-if="formProcess == 403">
				{{ t.error.access_denied_content }}
			</div>
			<div class="alert alert-danger" v-if="formProcess == 404">
				{{ t.error.notfound_content_list }}
			</div>
		</div>
		<symForm :options="opt" :data="formData" v-on:sended="getForm" :form="Form" :formProcess="formProcess" v-if="Form" />
	</div>
</template>
<script>

    import symForm from '@/components/form/symForm.vue'
    export default {
        name: 'paymentmethod',
        components: { symForm },
        data () {
            return {
                isLoading: false,
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                Form: null,
                translationForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: []
            }
        },
        watch: {
            '$route.params.id' () {
                this.getForm();
            }
        },
        mounted () {
            this.getForm();

        },
        methods: {
            resetStatus () {
                this.formProcess = 0;
            },
    async fetchRegions () {

        this.$http.get(api+'api/v1/regions')
            .then(response => {

            this.regions = response.body.result.regions;
    }, response => {

        })
    },
    async updateCK () {
        //for(var instanceName in CKEDITOR.instances)
        //CKEDITOR.instances[instanceName].updateElement();
    },
    async multiSelect () {

        var e = document.getElementsByClassName("choicesx");
        for (var i = 0; i < e.length; i++){
            var name = e[i].getAttribute("name");

            var element = e[i];

            var example = new Choices(element, {
                removeItemButton: true,

            });
        }


        //CKEDITOR.replaceAll();

    },
    async getForm (data) {

        if(!this.isLoading) {
            this.isLoading = true;
            this.Form = null;
            this.formProcess = 0;
            if(data) {

                //this.Form = null;
                this.$http.post(api+'api/v1/payment/methods/cep_bank',
                    data )
                    .then(response => {

                    this.Form = response.body.result;
                this.formProcess = 200;
                this.isLoading = false;
                //swal('', this.t.processing.success, "success")

                setTimeout(this.resetStatus, 5000);

            }, response => {
                    this.Form = response.body.result;
                    this.formProcess = 400;
                    this.isLoading = false;

                    //swal(this.t.processing.error, this.t.processing.check, "error")
                })

            } else {
                this.$http.get(api+'api/v1/payment/methods/cep_bank')
                    .then(response => {

                    this.Form = response.body.result;
                this.formData = response.body.form_data;
                this.opt.userGroup.label = 'group_name'
                this.isLoading = false;

            }, response => {
                    this.isLoading = false;
                    this.formProcess = response.status;
                })
            }
        }
    },
    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

	.cepbank_form_rsv .form-group {
		width: 50%;
		padding: 2px;
	}
	.cepbank_form_rsv .titlex {
		font-size: 18px;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/payments/form/cepbank.vue